<template>
  <div role="main">
    <div class="ibox data-filter">
      <div class="ibox-content px-3 pt-3 pb-2">

        <b-form @submit="onSubmitFilter">
          <b-row>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">Date</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="calendar-alt" />
                  </div>
                </div>
                <select
                  name="date"
                  id="filter-select-date"
                  class="form-control"
                  v-model="filter.date"
                  @change="requestData">

                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="weekly">Weekly</option>
                  <option value="lastweek">Last Week</option>
                </select>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">ID</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="id-card" />
                  </div>
                </div>
                <input
                  name="click_id"
                  placeholder="Search ID"
                  type="text"
                  id="filter-input-click-id"
                  class="form-control"
                  minlength="3"
                  v-model="filter.user"/>
                <div class="input-group-append">
                  <b-button type="submit" variant="dark">
                    <font-awesome-icon icon="check" /> Apply
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>

      </div>
    </div>

    <!--<transition appear appear-active-class="animated fadeIn">-->
      <div class="ibox" v-bind:class="{ full: fullscreen }">
        <div id="d-table-scroll" class="ibox-title">
          <span>
            Statistics
          </span>
          <div class="ibox-tools">
            <div role="group" arial-label="Action" class="btn-group btn-group-sm">
              <b-btn variant="secondary" v-on:click="requestData">
                <font-awesome-icon icon="sync-alt" :spin="processing" />
              </b-btn>
              <b-btn variant="secondary" v-on:click="toogleScreen">
                <font-awesome-icon v-bind:icon="fullscreen ? 'window-minimize' : 'window-maximize'"/>
              </b-btn>
            </div>
          </div>
        </div>

        <div class="ibox-content">
          <b-form v-if="fullscreen" @submit="onSubmitFilter">
            <b-row>
              <b-col cols="12" md="6" lg="4">
                <label for="filter-select-date" class="sr-only">Date</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <font-awesome-icon icon="calendar-alt" />
                    </div>
                  </div>
                  <select
                    name="date"
                    id="filter-select-date"
                    class="form-control"
                    v-model="filter.date"
                    @change="requestData">

                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="weekly">Weekly</option>
                    <option value="lastweek">Last Week</option>
                  </select>
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <label for="filter-select-date" class="sr-only">ID</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <font-awesome-icon icon="id-card" />
                    </div>
                  </div>
                  <input
                    name="click_id"
                    placeholder="Search ID"
                    type="text"
                    id="filter-input-click-id"
                    class="form-control"
                    v-model="filter.user"/>
                  <div class="input-group-append">
                    <b-button type="submit" variant="dark">
                      <font-awesome-icon icon="check" /> Apply
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form>

          <div class="table-beauty">
            <div class="table-responsive">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col" class="sorting">
                      ID
                      <a
                        href="#"
                        :class="getOrderByClass( 'click_id' )"
                        v-on:click="toggleOrderBy( $event, 'click_id'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Lead
                      <a
                        href="#"
                        :class="getOrderByClass( 'lead' )"
                        v-on:click="toggleOrderBy( $event, 'lead'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Payout
                      <a
                        href="#"
                        :class="getOrderByClass( 'amt' )"
                        v-on:click="toggleOrderBy( $event, 'amt'  )"/>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="odd" v-if="processing && !table.initial">
                    <td valign="center" colspan="5" class="no-hover">
                      <div class="loading-spinner"><div class="spin">Loading...</div></div>
                    </td>
                  </tr>
                  <tr class="odd" v-if="!table.rows.length && table.initial">
                    <td valign="top" colspan="5" class="no-hover text-center">No data available in table</td>
                  </tr>
                  <tr role="row" v-for="(item, index) in table.rows" v-bind:key="index" :class="index % 2 ? 'even' : 'odd'">
                    <td class="clickid-row">{{ item.click_id }}</td>
                    <td>{{ item.lead }}</td>
                    <td>{{ item.amt }}</td>
                  </tr>
                  <tr role="row" v-if="table.rows.length && table.initial" :class="table.rows.length % 2 ? 'even' : 'odd'" class="calculate">
                    <td class="text-nowrap">Total : <strong>{{ table.rows.length }}</strong></td>
                    <td><strong>{{ table.leads }}</strong></td>
                    <td><strong>${{ table.amt }}</strong></td>
                  </tr>
                </tbody>
              </table>

              <div class="table-beaury-loading" v-if="processing && table.initial"/>
            </div>
          </div>
        </div>
      </div>
    <!--</transition>-->
  </div>
</template>

<style>
  .calculate td {
    text-decoration: underline;
    border-top: 2px solid #dee2e6;
    border-style: dashed;
  }
</style>

<script>
  const Cookies = require( 'js-cookie' );
  const axios = require('axios');
  const CancelToken = axios.CancelToken;

  export default {
    data () {
      return {
        title: '',
        processing: false,
        fullscreen: false,
        filter: {
          date: 'today',
          user: ''
        },
        table: {
          initial: false,
          amt: 0,
          leads: 0,
          rows: [],
          requestCancel: null,
          orderBy: {
            key: 'amt',
            type: 'desc'
          },
          tempOrderBy: {
            key: 'amt',
            type: 'desc'
          }
        },
      };
    },
    created() {
      this.requestData();
    },
    filters: {
      uppercase: value => {
        if ( !value ) {
          return '';
        }

        return value.toUpperCase();
      }
    },
    methods: {
      getOrderByClass( key ) {
        const typeToClass = ( src ) => {
          if ( src === 'desc' ) {
            return 'sorting_desc';
          }
          if ( src === 'asc' ) {
            return 'sorting_asc';
          }
        };

        if ( this.table.orderBy.key === key ) {
          return typeToClass( this.table.orderBy.type );
        }

        return 'sorting';
      },
      toggleOrderBy( event, key ) {
        let type = 'desc';

        if ( this.table.orderBy.key === key ) {
          if ( this.table.orderBy.type === 'desc' ) {
            type = 'asc';
          }
          else {
            type = 'desc';
          }
        }

        if ( event.preventDefault ) {
          event.preventDefault();
          this.table.tempOrderBy = { key: key, type: type };
        }
        else {
          this.table.tempOrderBy = { key: event, type: type };
        }

        this.requestData();
      },
      requestData() {
        const url = `${process.env.VUE_APP_API_URL}/api/statistics/${this.filter.date}`;
        const token = Cookies.get('__token');
        const dataParams = { };

        dataParams['order-by'] = this.table.tempOrderBy;

        if ( this.filter.user && this.filter.user.trim().length ) {
          dataParams.user = this.filter.user.trim();
        }

        if ( this.requestCancel ) {
          this.requestCancel( 'Request cancel' );
        }

        const instance = axios.create( );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.processing = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        return instance.get( url, {
          cancelToken: new CancelToken( cancel => {
            this.requestCancel = cancel;
          }),
          params: dataParams
        } ).then( response => {
          const data = response.data;

          this.table.amt = 0;
          this.table.leads = 0;

          data.rows.map(item => {
            if ( item.amt ) {
              this.table.amt += item.amt;
              item.amt = '$' + item.amt.toFixed( 4 );
            }
            else {
              item.amt = '$0.0000';
            }

            if ( item.lead ) {
              this.table.leads += parseInt( item.lead, 10 );
            }

            return item;
          });

          this.table.rows = data.rows;
          this.table.amt = this.table.amt.toFixed( 4 );
          this.table.orderBy = this.table.tempOrderBy;

          if ( false === this.table.initial ) {
            this.table.initial = true;
          }

          this.processing = false;

          return response;
        } ).catch( error => {
          if ( false === axios.isCancel( error ) ) {
            if ( false === this.table.initial ) {
              this.table.initial = true;
            }

            this.processing = false;
          }

          if ( !error.response ) {
            // eslint-disable-next-line
            console.log( error );
            return;
          }

          const response = error.response;

          if ( response.status == 401 || response.status == 403 ) {
            this.$store.dispatch( 'authentication/logout' );
            this.$router.push('/login');
          }
        } );
      },
      toogleScreen() {
        if (this.fullscreen) {
          this.fullscreen = false;
          window.document.body.style.overflow = 'initial';
        }
        else {
          this.fullscreen = true;
          window.document.body.style.overflow = 'hidden';
        }
      },
      onSubmitFilter( event ) {
        event.preventDefault();

        this.requestData();
      }
    },
    beforeRouteLeave( to, from, next ) {
      this.processing = true;
      next();
    }
  };
</script>